// Zichtbaarheidsdetectie op alleen de verticale as, voor elementen
// waarvan de horizontale positie niet relevant is (bijv. slides die
// horizontaal buiten beeld staan). Meldt wijzigingen als batch aan de
// callback: [{ element, inViewport }].
class YAxisWatcher {
	constructor(onChanges) {
		this.onChanges = onChanges;
		this.elements = [];
		this.handler = null;
		this.queued = false;
	}

	watch(element) {
		this.elements.push(element);
		this.addListeners();
	}

	unwatch(element) {
		this.elements = this.elements.filter(el => el !== element);

		if (this.elements.length === 0) {
			this.removeListeners();
		}
	}

	destroy() {
		this.removeListeners();
		this.elements = [];
	}

	check() {
		if (this.elements.length === 0) return;

		let viewportHeight = window.innerHeight;

		this.onChanges(this.elements.map(element => {
			let rect = element.getBoundingClientRect();

			return {
				element,
				inViewport: rect.bottom > 0 && rect.top < viewportHeight
			};
		}));
	}

	queueCheck() {
		if (this.queued) return;

		this.queued = true;
		requestAnimationFrame(() => {
			this.queued = false;
			this.check();
		});
	}

	addListeners() {
		if (this.handler) return;

		this.handler = this.queueCheck.bind(this);

		window.addEventListener('scroll', this.handler, { passive: true });
		window.addEventListener('resize', this.handler, { passive: true });
		window.addEventListener('load', this.handler);
	}

	removeListeners() {
		if (!this.handler) return;

		window.removeEventListener('scroll', this.handler);
		window.removeEventListener('resize', this.handler);
		window.removeEventListener('load', this.handler);
		this.handler = null;
	}
}

export default YAxisWatcher;
